import React from 'react'

import HeroProductMolecule  from '@/molecules/Heroes/HeroProduct'

const HeroProduct = (props) => (
  <HeroProductMolecule {...props} />
)

export default HeroProduct
